const nutritionRoutes = {
  // Cliente: "Mi Programa"
  clientProgram: {
    path: '/mi-programa'
  },
  // Admin/entrenador: autoría de programas y recetarios
  adminNutrition: {
    path: '/nutrition'
  }
};

export default nutritionRoutes;
